// Shared by the FAQ section and the FAQ JSON-LD schema on the home page.
const homeFaqs = [
  {
    q: "How much does website development cost?",
    a: "The cost depends on your project scope, number of pages, features, integrations, design requirements, and technology. Share your requirements with us for a tailored estimate.",
  },
  {
    q: "How long does it take to build a website?",
    a: "A simple business website usually takes 2–4 weeks, while e-commerce stores and custom web applications can take 6–12 weeks or more depending on features and feedback cycles.",
  },
  {
    q: "Will my website work on mobile devices?",
    a: "Yes. Every website we build is fully responsive and tested on phones, tablets, and desktops so your users get a smooth experience on any screen.",
  },
  {
    q: "Can you redesign my existing website?",
    a: "Absolutely. We can refresh the design, improve speed and SEO, and migrate your content to a modern, easy-to-manage platform without losing what already works.",
  },
  {
    q: "Will I be able to update my website content?",
    a: "Yes. We can build on a CMS or add an admin panel so your team can update text, images, products, and blogs without depending on developers.",
  },
  {
    q: "Do you provide maintenance after launch?",
    a: "Yes. We offer ongoing support and maintenance plans covering updates, security, backups, performance monitoring, and small enhancements.",
  },
  {
    q: "What do you need to start a project?",
    a: "A short brief about your business, goals, target audience, and any reference websites is enough to start. We will guide you through the rest in a discovery call.",
  },
  {
    q: "How do I get a quote?",
    a: "Fill in the free consultation form below or contact us directly. We will review your requirements and share a detailed proposal with timeline and cost.",
  },
];

export default homeFaqs;
